import React, { useEffect, useState } from "react";
import ProfileLayout from "../../layout/ProfileLayout";
import { profileService } from "../../services";
import { Panel, PanelHead, PhoneField, TextField, isValidPhone } from "../../components/ui";

export default function ProfileSettings() {
  const [profile, setProfile] = useState(null);
  const [form, setForm] = useState({ fullname: "", phone: "", email: "", address: "" });
  const [password, setPassword] = useState({ next: "", confirm: "" });
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    profileService.get().then((data) => {
      setProfile(data);
      setForm({
        fullname: data?.fullname || "",
        phone: data?.phone || "",
        email: data?.email || "",
        address: data?.address || "",
      });
    });
  }, []);

  const onChange = (key) => (event) => setForm((prev) => ({ ...prev, [key]: event.target.value }));

  const saveProfile = async (event) => {
    event.preventDefault();
    setMessage("");
    setError("");
    if (form.phone && !isValidPhone(form.phone)) {
      setError("เบอร์โทรศัพท์ต้องเป็นตัวเลข 10 หลัก");
      return;
    }
    setSaving(true);
    try {
      await profileService.update(form);
      setMessage("บันทึกข้อมูลสมาชิกเรียบร้อย");
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  const changePassword = async (event) => {
    event.preventDefault();
    setMessage("");
    setError("");
    if (password.next.length < 6) return setError("รหัสผ่านต้องมี 6 ตัวอักษรขึ้นไป");
    if (password.next !== password.confirm) return setError("รหัสผ่านใหม่ไม่ตรงกัน");

    setSaving(true);
    try {
      await profileService.changePassword({ password: password.next });
      setPassword({ next: "", confirm: "" });
      setMessage("เปลี่ยนรหัสผ่านเรียบร้อย");
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  const copyUid = () => navigator.clipboard?.writeText(profile?.uid || "");

  return (
    <ProfileLayout>
      <Panel>
        <PanelHead
          title="👤 ตั้งค่าสมาชิก"
          action={profile?.memberSince ? <span className="lt-helper">เป็นสมาชิกเมื่อ {profile.memberSince}</span> : null}
        />

        <form onSubmit={saveProfile}>
          <div className="lt-grid-2">
            <TextField label="ชื่อบัญชี" value={form.fullname} onChange={onChange("fullname")} />
            <div className="lt-field">
              <span className="lt-field__label">UID</span>
              <div className="lt-inline-input">
                <input className="lt-input" value={profile?.uid || ""} readOnly />
                <button type="button" className="lt-btn lt-btn--ghost" onClick={copyUid}>
                  📋
                </button>
              </div>
            </div>
            <TextField label="อีเมล" type="email" value={form.email} onChange={onChange("email")} />
            <PhoneField label="เบอร์โทรศัพท์" value={form.phone} onChange={onChange("phone")} />
          </div>

          <TextField label="ที่อยู่" value={form.address} onChange={onChange("address")} />

          <button type="submit" className="lt-btn lt-btn--navy lt-btn--block" disabled={saving}>
            บันทึกข้อมูลสมาชิก
          </button>
        </form>

        <PanelHead title="🔒 เปลี่ยนรหัสผ่าน" />
        <form onSubmit={changePassword}>
          <div className="lt-grid-2">
            <TextField
              label="รหัสผ่านใหม่"
              type="password"
              placeholder="กรอกรหัสผ่านใหม่"
              value={password.next}
              onChange={(event) => setPassword((prev) => ({ ...prev, next: event.target.value }))}
              autoComplete="new-password"
            />
            <TextField
              label="รหัสผ่านใหม่อีกครั้ง"
              type="password"
              placeholder="กรอกรหัสผ่านใหม่อีกครั้ง"
              value={password.confirm}
              onChange={(event) => setPassword((prev) => ({ ...prev, confirm: event.target.value }))}
              autoComplete="new-password"
            />
          </div>

          {message ? <p className="lt-helper">{message}</p> : null}
          {error ? <p className="lt-helper lt-helper--danger">{error}</p> : null}

          <button type="submit" className="lt-btn lt-btn--teal lt-btn--block lt-btn--cut" disabled={saving}>
            เปลี่ยนรหัสผ่าน
          </button>
        </form>
      </Panel>
    </ProfileLayout>
  );
}
